<div
  class="mbs-form"
  [formGroup]="tagSearchForm">
  <div class="row py-1 mb-3">
    <div class="col-12">
      <mbs-input
        formControlName="name"
        [placeholder]="'shared:placeholders.search' | i18next"
        [appendButtons]="[
          {
            type: 'secondary',
            icon: 'ico ico-Search'
          }
        ]"
        [clearButton]="true"
        (buttonClick)="search()">
      </mbs-input>
    </div>
  </div>
</div>

<mbs-table-grid
  [headers]="headers"
  [loading]="loading"
  [data]="data"
  [selectedItems]="selected"
  (changeSelected)="onSelectedRowsChanged($event)"
  [multipleSelect]="multipleSelect"
  [showSelectAllCheckbox]="true"
  [selectAllIgnoreDisabled]="true"
  [showTableCheckboxes]="true"
  [showSelectAllHint]="false"
  [selectable]="true"
  [keepState]="true"
  [virtualScrolling]="true"
  [myTrackBy]="trackBy"
  [serverSidePagination]="false"
  [maxHeight]="'50vh'"
  [noDataMessage]="noDataText"
  [totalItems]="total">
  <ng-template
    mbsTableCell
    let-item>
    <mbs-tag [color]="item.color">
      {{ item.name }}
    </mbs-tag>
  </ng-template>
</mbs-table-grid>
